import { ModelDataType } from 'src/app/interfaces/model-data-type';

import { BaseModel } from './base-model';
import { BusinessVerificationApiError } from './business-verification-api-error';
import { ClientRegisteredVendor } from './client-registered-vendor';
import { ClientRegisteredVendorInvoiceFee } from './client-registered-vendor-invoice-fee';
import { Company } from './company';
import { User } from './user';

export class ClientRegisteredVendorInvoice extends BaseModel {
  static override columnMap = new Map<
    string,
    { property: string; type: 'column'; dataType: ModelDataType }
  >();
  static override associationMap = new Map<
    string,
    { property: string; type: 'association'; model: string }
  >();
  static override aliasedColumnMap = new Map<
    string,
    { property: string; type: 'alias' }
  >();

  static ClientRegisteredVendorInvoiceProperties: (
    | {
        property: keyof ClientRegisteredVendorInvoice;
        type: 'column';
        dataType: ModelDataType;
      }
    | {
        property: keyof ClientRegisteredVendorInvoice;
        type: 'alias';
      }
    | {
        property: keyof ClientRegisteredVendorInvoice;
        type: 'association';
        model: string;
      }
  )[] = [
    { property: 'id', type: 'column', dataType: 'number' },
    { property: 'CompanyId', type: 'column', dataType: 'number' },
    {
      property: 'ClientRegisteredVendorId',
      type: 'column',
      dataType: 'number'
    },
    { property: 'UserId', type: 'column', dataType: 'number' },
    { property: 'feeType', type: 'column', dataType: 'string' },
    { property: 'feeAmt', type: 'column', dataType: 'number' },
    { property: 'isTinCheckValid', type: 'column', dataType: 'boolean' },
    { property: 'isLexisNexisV2Valid', type: 'column', dataType: 'boolean' },
    {
      property: 'isLexisNexisLegacyValid',
      type: 'column',
      dataType: 'boolean'
    },
    { property: 'createdAt', type: 'column', dataType: 'date' },
    { property: 'updatedAt', type: 'column', dataType: 'date' },

    { property: 'Company', model: 'Company', type: 'association' },
    {
      property: 'ClientRegisteredVendor',
      model: 'ClientRegisteredVendor',
      type: 'association'
    },
    { property: 'User', model: 'User', type: 'association' },
    {
      property: 'BusinessVerificationApiError',
      model: 'BusinessVerificationApiError',
      type: 'association'
    },
    {
      property: 'ClientRegisteredVendorInvoiceFee',
      model: 'ClientRegisteredVendorInvoiceFee',
      type: 'association'
    }
  ];

  static {
    ClientRegisteredVendorInvoice.ClientRegisteredVendorInvoiceProperties.forEach(
      (propertyObject) => {
        const { property, type } = propertyObject;
        if (type === 'column') {
          ClientRegisteredVendorInvoice.columnMap.set(property, propertyObject);
        }
        if (type === 'alias') {
          ClientRegisteredVendorInvoice.aliasedColumnMap.set(
            property,
            propertyObject as { property: string; type: 'alias' }
          );
        }
        if (type === 'association') {
          ClientRegisteredVendorInvoice.associationMap.set(
            property,
            propertyObject as {
              property: string;
              type: 'association';
              model: string;
            }
          );
        }
      }
    );
  }

  constructor(
    ClientRegisteredVendorInvoiceObject: Partial<ClientRegisteredVendorInvoice>
  ) {
    super();

    ClientRegisteredVendorInvoice.ClientRegisteredVendorInvoiceProperties.forEach(
      (propertyObject) => {
        const { property } = propertyObject;
        const value = ClientRegisteredVendorInvoiceObject[property];
        if (value !== undefined) {
          Object.assign(this, { [property]: value });
        }
      }
    );
  }

  id?: number;
  CompanyId?: number;
  ClientRegisteredVendorId?: number | null;
  feeType?: 'STANDARD' | 'TINCHECK ONLY';
  feeAmt?: number;
  UserId?: number;
  isTinCheckValid?: boolean;
  isLexisNexisV2Valid?: boolean;
  isLexisNexisLegacyValid?: boolean;
  createdAt?: Date;
  updatedAt?: Date;

  Company?: Company;
  ClientRegisteredVendor?: ClientRegisteredVendor;
  User?: User;
  BusinessVerificationApiError?: BusinessVerificationApiError;
  ClientRegisteredVendorInvoiceFee?: ClientRegisteredVendorInvoiceFee;
}

/*

ClientRegisteredVendorInvoice.associate = (models) => {
  ClientRegisteredVendorInvoice.hasMany(models.BusinessReportsClientRegisteredVendorInvoice, { foreignKey: 'ClientRegisteredVendorInvoiceId' });
  ClientRegisteredVendorInvoice.hasMany(models.ClientRegisteredVendorInvoiceResult);
  ClientRegisteredVendorInvoice.hasMany(models.ClientRegisteredVendorInvoiceResult, { as: 'ArchivedClientRegisteredVendorInvoiceResults', scope: { isArchived: true } });
};
*/
